import React from 'react';
import { Accordion } from '../../../../flayr-components/Accordion/Accordion';

interface IProviderProfileCollapseContainerProps {
  title?: React.ReactNode;
  titleClassName?: string;
  open?: boolean;
  disabled?: boolean;
  hideTitle?: boolean;
  hideIcon?: boolean;
  titleTextSize?: string;
}

const ProviderProfileCollapseContainer: React.FC<React.PropsWithChildren<IProviderProfileCollapseContainerProps>> = ({
  children,
  open,
  title,
  titleClassName = '',
  disabled,
  hideIcon,
  hideTitle,
  titleTextSize = 'text-lg leading-[1.5em] md:text-4xl',
}) => {
  return (
    <div className="py-2">
      <Accordion
        titleClassName={`text-black font-medium ${titleTextSize} ${titleClassName}`}
        iconClassName="text-black"
        open={open}
        title={title}
        hideIcon={hideIcon}
        onToggle={() => disabled}
        hideTitle={hideTitle}
      >
        <div className="py-2 text-gray-5E text-sm lg:text-xl leading-[24px]">
          {children}
        </div>
      </Accordion>
    </div>
  );
};
export default ProviderProfileCollapseContainer;
